module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "content clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(" Copyright " + _vm._s(_vm.year) + " "), _c('strong', [_vm._v(" Bioseco S.A.")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.about')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.contact')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.privacy')))])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('footer.created')))]), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "fb-icon",
    attrs: {
      "href": "https://www.facebook.com/Bioseco-497515667013273/",
      "target": "_blank"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "linked-icon",
    attrs: {
      "href": "https://pl.linkedin.com/company/bioseco/",
      "target": "_blank"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/soppo-logo.svg",
      "alt": "soppo-logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fcb7c94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterMain.vue
// module id = 294
// module chunks = 0